// extracted by mini-css-extract-plugin
export var button = "_2u-1";
export var featuredLink = "_2u-4";
export var spinner = "_2u-2";
export var spinnerContainer = "_2u-3";
export var text = "_2u-0";